module.exports = __webpack_public_path__ + "static/features-889d77723897f7726d0ce0462f53f695.svg";